<template>
    <div>
        <Header backButton></Header>
        <div class="conversations">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <div class="contenu pt-10 indexUp">
                <p class="text-3xl mb-10 leading-tight">Conversations</p>

                <div class="list-group">
                    <router-link
                        class="list-group-item"
                        v-for="conversation in conversations"
                        :key="conversation.id"
                        :to="{path: '/conversations/' + conversation.id + '/messages'}"
                    >
                        <div class="media mb-4 pb-4 dashed-space-1px">
                            <div class="media-left mr-4">
                                <img
                                    class="media-object img-circle"
                                    :src="(conversation.attributes[conversation.attributes.noyou].attributes.custom_pictures[0]) ? conversation.attributes[conversation.attributes.noyou].attributes.custom_pictures[0].link : conversation.attributes[conversation.attributes.noyou].attributes.private_avatar"
                                >
                            </div>
                            <div class="media-body">
                                <h4
                                    class="font-bold text-lg media-heading"
                                >{{ (conversation.attributes[conversation.attributes.noyou].attributes.custom_first_name ) ? conversation.attributes[conversation.attributes.noyou].attributes.custom_first_name : conversation.attributes[conversation.attributes.noyou].attributes.private_pseudo }}</h4>
                                <span
                                    class="text-xs notification-location"
                                >{{ (conversation.attributes.messages[0]) ? conversation.attributes.messages[0].attributes.message : 'Envoyez le premier message !' }}</span>
                            </div>
                            <div
                                class="text-xs notification-time"
                            >{{ diffDate(conversation.attributes.updated_at) }}</div>
                        </div>
                        <hr>
                    </router-link>
                </div>
            </div>
            <Navigation></Navigation>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";

export default {
    name: "conversations",
    components: {
        Navigation,
        Header
    },
    data() {
        return {
            error: null,
            conversations: null,
            pseudo: ""
        };
    },
    mounted() {
        this.axios
            .get("/api/auth/user")
            .then(response => {
                if (response.status == 200) {
                    this.user = response.data;

                    this.axios
                        .get("/api/users/" + this.user.id + "/conversations")
                        .then(response => {
                            this.conversations = response.data.data;
                        });
                }
            })
            .catch(errors => {
                this.error = errors.data;
            });
    },
    computed: {
        user: {
            get() {
                return this.$store.getters.currentAppUserData;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    },
    methods: {
        diffDate(updated_at) {
            let today = new Date();
            let date = new Date(updated_at);
            let diffMs = Math.abs(date - today); // milliseconds
            let diffDays = Math.abs(Math.floor(diffMs / 86400000)); // days
            let diffHrs = Math.abs(Math.floor((diffMs % 86400000) / 3600000)); // hours
            let diffMins = Math.abs(
                Math.round(((diffMs % 86400000) % 3600000) / 60000)
            ); // minutes

            return diffMins + " minutes";
        },
        send(e) {
            e.preventDefault();

            this.axios
                .post("/api/auth/login", {
                    email: this.email,
                    password: this.password,
                    remember_me: true
                })
                .then(response => {
                    localStorage.setItem("token", response.data.access_token);

                    this.axios.defaults.headers.common = {
                        Authorization: `Bearer ${response.data.access_token}`
                    };

                    this.$router.push("/about");
                })
                .catch(error => {
                    this.$router.push("/login");
                });
        }
    }
};
</script>

<style scoped lang="scss">
.conversations {
    height: 100%;
    margin-top: 60px;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px 70px 34px;
        text-align: left;

        .list-group {
            position: relative;
            width: 100%;
        }

        .media {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            background-color: rgba(255, 255, 255, 0.2);
            padding: 10px 10px 20px 10px;
            max-height: 100px;
        }

        .media-left img {
            height: 50px;
            max-width: 50px;
            width: 50px;
            border-radius: 50%;
        }

        .media-heading {
            margin-top: 0;
            margin-bottom: 5px;
        }
        .media-body {
            width: 80%;
        }
    }
    .notification-time {
        text-align: center;
        top: 10px;
        position: relative;
    }
}
</style>